export * from './full-layout';
export * from './simple-layout';
export * from './admin-layout'


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/index.ts